// Yonex CPH — scroll-reveal controller
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document
      .querySelectorAll('[data-yonex-reveal], .yonex-reveal')
      .forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document
      .querySelectorAll('[data-yonex-reveal], .yonex-reveal')
      .forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08,
    }
  );

  function observeAll() {
    document
      .querySelectorAll('[data-yonex-reveal], .yonex-reveal:not(.is-revealed)')
      .forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-observe on Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', observeAll);
})();
